<!--
        Message Container
          1. Error Background Color will displayed (Red), if 'isErrorMessage' is true
          2. Success Background Color will displayed (Green), if 'isErrorMessage' is false
-->
<div
  class="message-container"
  [ngClass]="{
    'message-container--error': isErrorMessage,
    'message-container--success': !isErrorMessage,
  }"
>
  <div class="row">
    <!--
        Left Side Column
          1. Error Icon (shown if 'isErrorMessage' is true)
          2. Success Icon (shown if 'isErrorMessage' is false)
    -->
    <div class="col-lg-1 col-md-1 col-sm-1 col-1 icon-align">
      <span class="status-icon">
        <i class="fa fa-ban status-icon--md" *ngIf="isErrorMessage"></i>
        <i class="fa fa-check-circle-o status-icon--md" *ngIf="!isErrorMessage"></i>
      </span>
    </div>
    <!--
        Right Side Column
          1. Title (Bind with @Input() title (String))
          2. Description (Bind with @Input() description (String) )
          3. Suggestions (Bind with @Input() suggestions (Array) )
              1. Suggestions is a Unordered List with List Item
              2. Each List Item in Bind with suggestions Array Element
    -->
    <div class="col-lg-11 col-md-11 col-sm-11 col-11 message-align">
      <div class="status-message">
        <!--1-->
        <span class="status-header">{{ title }}</span>
        <div class="status-content">
          <!--2-->
          <p class="description error-text-pos">{{ description }}</p>
          <!--3-->
          <p class="content-header" *ngIf="suggestions">Suggestions</p>
          <ul class="content-list" *ngIf="suggestions">
            <li *ngFor="let suggestion of suggestions; trackBy: trackByIdentity">
              {{ suggestion }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
